$(document).ready(function() {
    // Affichage de l'icône lorsque le premier caractère est tapé
    $('.a-input').on('input', function() {
        if ($(this).val().length > 0) {
            $(this).siblings('.toggle-password').show();
        } else {
            $(this).siblings('.toggle-password').hide();
        }
    });

    // Bascule entre le type password et text
    $('.toggle-password').on('click', function() {
        var input = $(this).siblings('.a-input');
        if (input.attr('type') === 'password') {
            input.attr('type', 'text');
            $(this).find('.icon-no-view').addClass('icon-view').removeClass('icon-no-view');
        } else {
            input.attr('type', 'password');
            $(this).find('.icon-view').addClass('icon-no-view').removeClass('icon-view');
        }
    });
});